import { Injectable } from '@angular/core';
import { IdexService } from '../idex.service';
import { HttpParams } from '@angular/common/http';
@Injectable({ providedIn: 'root' })
export class EformAPI {
   constructor(private service: IdexService) { }

   getEForm(formId: number, version?: string) {
      const url = 'eform/get/' + formId;
      const api = (version ? url + '?version=' + version : url);

      return this.service.get(api);
   }

   getEFormFile(alfId: number) {
      const api = 'eform/file/get/' + alfId;
      return this.service.get(api);
   }

   getEFormFormDocId(docId: string) {
      const lang = localStorage.getItem('lang') || 'en';
      const api = 'eform/get/doc/' + docId + '?locale=' + lang;
      return this.service.get(api);
   }

   listGroups(siteCode: string, ids: any, params: any, size?:any, filterValue?:any, sort?:any) {
      var url = '/eform/groups/' + ids + '?siteCode=' + siteCode;
      if(size){
         url += `&size=${size}&searchText=${filterValue}`
      }
      if(sort){
         url += `&sort=${sort}`
      }
      return this.service.get(url, { params });
   }

   listEForm(formtype: string, tin: string, filterValue: string, orderBy: any, orderType: any, index: any, size: any, params: any) {
      return this.service.get('/eform/list/' + formtype + '?tin=' + tin + '&searchText=' + filterValue + '&orderBy=' + orderBy +
         '&orderType=' + orderType + '&index=' + index + '&size=' + size, { params });
   }

   listEFormOnlyActive(formtype: string, tin: string, filterValue: string, orderBy: any, orderType: any, index: any, size: any, params: any) {
      return this.service.get('/eform/list/active/' + formtype + '?tin=' + tin + '&searchText=' + filterValue + '&orderBy=' + orderBy +
         '&orderType=' + orderType + '&index=' + index + '&size=' + size, { params });
   }

   listFormName(formName: string , isSearch: boolean) {
      return this.service.get('eform/listFormName/' + formName  + '?isSearch=' + isSearch);
   }

   listFormTin(formName: string , isSearch: boolean , tin: any, isActive?: boolean) {
      let params = new HttpParams().set('formName', formName).set('isSearch', isSearch);
      params = params.set('tin', tin);
      if(isActive !== undefined){
         params = params.set('isActive', isActive);
      }
      return this.service.get('eform/listFormTin', { params });
   }

   activeFormList(id: number, isActive: boolean) {
      return this.service.put('/eform/active/' + id + '?isActive=' + isActive);
   }

   submitEForm(actions: string, id: any, data: any, docId: string) {
      if (!docId) {
         docId = '0';
      }
      return this.service.post('/eform/submit/' + actions + '/' + id + '/' + docId, data);
   }

   getConfigDecimalPlace() {
      return this.service.get('/eform/config/decimal-place');
   }

   setConfigDecimalPlace(decimalPlace: number) {
      return this.service.get('/eform/config/decimal-place/' + decimalPlace);
   }

   heartBeat() {
      return this.service.get('eform/config/heart-beat');
   }

   getTimeout() {
      return this.service.get('eform/config/get-timeout');
   }

   getCountry(lang?:string) {
      const url = lang ? 'eform/master/country?lang=' + lang : 'eform/master/country';
      return this.service.get(url);
   }

   getProvince(lang?:string) {
      const url = lang ? 'eform/master/province?lang=' + lang :'eform/master/province';
      return this.service.get(url);
   }

   getDistrictWithProvince(provinceCode: number ,lang?:string) {
      const url = lang ? 'eform/master/district/' + provinceCode +'?lang='+ lang : 'eform/master/district/' + provinceCode;
      return this.service.get(url);
   }

   getSubDistrictWithDistrict(districtCode: number ,lang?:string) {
      const url = lang ? 'eform/master/sub-district/' + districtCode + '?lang=' + lang :'eform/master/sub-district/' + districtCode;
      return this.service.get(url);
   }

   getZipCodeWithSubDistrict(subDistrictCode: number) {
      return this.service.get('eform/master/zip-code/' + subDistrictCode);
   }

   deleteFormList(formId: number) {
      const url = 'eform/delete/' + formId;
      return this.service.put(url);
   }

   getTitleName(title: string, lang: string, type: string) {
      let params = new HttpParams().set('title', title).set('lang', lang).set('type', type);
      return this.service.get('eform/master/titleName', { params });
   }

   getListMasterTable(tin: string) {
      return this.service.get('eform/master/v1/get/list?tin=' + tin);
   }

   createLookup(tableName: string, accessType: string, data: any, resourceName?: string) {
      return this.service.post('eform/master/v1/lookup/create?tableName=' + tableName
                               + '&accessType=' + accessType + '&resourceName=' + resourceName, data);
   }

   getLookup(id: string) {
      return this.service.get('eform/master/v1/lookup/get/' + id);
   }

   existingTableName(company: string, tableName: string) {
      return this.service.get('eform/master/v1/get/check/table/' + company + '?table=' + tableName);
   }

   checkedFormName(formName: string, tin: string, formType: string) {
      const encodedFormName = encodeURIComponent(formName);
      let params = new HttpParams().set('formName', encodedFormName);

      if (tin !== "" && formType !== "") {
        params = params.set('tin', tin).set('formType', formType);
      }

      return this.service.get('eform/check', { params });
    }

   checkedFormNameAll(formName: string, tin: string, formType: string) {
      const encodedFormName = encodeURIComponent(formName);
      let params = new HttpParams().set('formName', encodedFormName);

      if (tin !== "" && formType !== "") {
         params = params.set('tin', tin).set('formType', formType);
      }

      return this.service.get('eform/check/all', { params });
   }

   selectEForm(formId: any, formName: string, tin: string) {
      const lang = localStorage.getItem('lang') || 'en';
      let params = new HttpParams();
      params = params.set('formName', formName);
      params = params.set('tin', tin);
      const api = 'eform/select/' + formId + '?locale=' + lang;

      return this.service.post(api,null, {params});
   }

}
